<template>
  <div id="rgp">
    <!--本体-->
    <div class="zhanghao">
      <p class="p-title">充值账号信息</p>

      <!--账号-->
      <div v-if="type">
        <p class="flex-box input-p">
          <span>账号：</span>
          <input type="text" v-model="zhanghao" placeholder="请输入账号" />
        </p>
        <p class="flex-box input-p">
          <span>密码：</span>
          <input type="password" v-model="pass" placeholder="请输入密码" />
        </p>
      </div>

      <!--手机号-->
      <div class="phone-login" v-else>
        <p class="flex-box input-p">
          <span>手机号：</span>
          <input type="tel" v-model="phone" maxlength="11" placeholder="请输入账号" />
        </p>
        <p class="flex-box input-p relativeItem">
          <span>图形验证码：</span>
          <input type="text" v-model="imgcode" placeholder="请输入图片验证码" />
          <img :src="imgcodeurl" class="imgy centerY absoluteItem" @click="getImgCode" v-if="imgcodeurl!=''"/>
        </p>
        <p class="flex-box input-p relativeItem">
          <span>验证码：</span>
          <input type="text" v-model="yzm" placeholder="请输入验证码" />
          <span
            class="centerY absoluteItem yzm-span"
            :class="{ disable : !getCode }"
            @click="gcode"
          >{{ codeText }}</span>
        </p>
      </div>

      <p class="error" v-if="info.is_phone != 1">朱贝号未绑定手机用户，无法使用珍珠兑钻功能</p>

      <!--切换账号按钮-->
      <span class="change-an" @click="change_zh">{{ change_test }}</span>
    </div>

    <!--充值金额-->
    <div class="count whiteB">
      <p>请选择兑换档位</p>
      <ul class="flex-box">
        <li
          v-for="(n,index) in list"
          :key="index"
          :class="{active:actived == index}"
          @click=" actived = index"
        >
          <p class="p1">
            <span>{{ n.diamond }}钻石</span>
          </p>
          <p class="p2">
            <span>{{ n.pearl }}</span>珍珠
          </p>
        </li>
      </ul>
    </div>

    <!--充值按钮-->
    <p class="error c-error">{{ error_msg }}</p>
    <div class="an">
      <button class="relativeItem" @click="showPayWay">
        <a class="allA opacity" v-show="!pay || info.is_phone != 1" @click.stop></a>
        确认兑换
      </button>
    </div>

    <!--个人信息-->
    <div class="mine flex-box">
      <div class="flex-box">
        <img :src="info.avatar" class="noevents-img imgBlock" />
        <div>
          <p class="p1 apostrophe">{{ info.nickname }}</p>
          <p class="p2">{{ info.usernumber }}</p>
        </div>
      </div>
      <div class="balance">
        <p class="p1">我的钻石</p>
        <p class="p2">{{ info.balance }}</p>
      </div>
    </div>
  </div>
</template>








<script>
export default {
  name: "recharge",
  components: {},
  data() {
    return {
      type: 2, //1、账号充值 2、手机号充值
      zhanghao: "",
      pass: "",
      phone: "",
      yzm: "",
      imgcodeurl: "",
      imgcode: "",
      codeText: "获取验证码",
      change_test: "切换手机登录",
      getCode: true,
      error_msg: "",
      xy: false,
      actived: 0,
      pay: false,
      info: [], //个人信息
      list: [] //充值金额的列表
    };
  },
  methods: {
    //获取验证码
    gcode() {
      if (this.getCode) {
        this.getCode = false;
      } else {
        return;
      }

      let _this = this;
      let data = {
        phone: this.phone,
        imgcode: this.imgcode.toLowerCase(),
        type:7
      };
      this.$jsonp(this.$apis("z_h_code"), data, res => {
        if (res.data.data.msg == '发送成功') {
          _this.$tool.tip("验证码已发送", "30%");
          //发送成功
          _this.getCode = false;
          let num = 59;
          let co = setInterval(() => {
            num--;
            _this.codeText = "已发送(" + num + ")";
            if (num == 0) {
              clearInterval(co);
              _this.codeText = "发送验证码";
              _this.getCode = true;
            }
          }, 1000);
        } else {
          _this.getCode = true;
          _this.$tool.tip(res.data.data.msg, "30%");
        }
      });
    },

    /**获取图片yzm */
    getImgCode() {
      let _this = this;
      _this.imgcodeurl = '';
      this.$jsonp(this.$apis("z_h_imgcode"), {phone:this.phone}, res => {
        _this.imgcodeurl += 'data:image/jpeg;base64,' + res.data.data.img;
      });
    },

    /**请求充值金额的列表 */
    getMoneyList() {
      let _this = this;
      let data = {};
      this.$jsonp(this.$apis("rechargeMoneyList"), data, res => {
        _this.list = res.data.data.result;
      });
    },

    //获取个人信息
    getInfo() {
      let _this = this;
      let data = {};
      this.$jsonp(this.$apis("z_h_z"), data, res => {
        _this.info = res.data.data.data;
        _this.list = res.data.data.data.list;
        _this.zhanghao = _this.info.account;
      });
    },

    //改变账号登录方式
    change_zh() {
      this.type = !this.type;
    },

    /**账号等input变化时触发的判断方法 */
    is_pay() {
      if (this.type) {
        if (this.zhanghao.length > 0 && this.pass.length > 0) {
          this.pay = true;
        } else {
          this.pay = false;
        }
      } else {
        if (this.$tool.checkPhone(this.phone) && this.yzm.length >= 4) {
          this.pay = true;
        } else {
          this.pay = false;
        }
      }
    },

    /**确认充值 */
    showPayWay() {
      this.pay = false;
      let _this = this;
      let data = {
        sort:this.list[this.actived].sort
      };
      if (this.type) {
        data.type = 1;
        data.account = this.zhanghao;
        data.password = this.pass;
      }else{
        data.type = 2;
        data.phone = this.phone;
        data.code = this.yzm;        
      }
      this.$jsonp(this.$apis("z_h_z_pay"), data, res => {
        if (res.data.data.status == 200) {
          //兑换成功
          _this.info.balance = res.data.data.balance;
          _this.$tool.tip('兑换成功',"30%");
        }else{
          //兑换失败
          _this.error_msg = res.data.data.msg;
        }
        _this.pay = true;
      });
    }
  },
  mounted: function() {
    this.$tool.setTitle("珍珠兑钻");
    //获取充值金额的列表
    this.getInfo();
  },
  watch: {
    type(val) {
      this.zhanghao = this.info.account;
      this.pass = "";
      this.phone = "";
      this.yzm = "";
      this.pay = false;
      this.error_msg = "";
      this.imgcode = "";
      if (val) {
        this.change_test = "切换手机登录";
      } else {
        this.change_test = "切换账号登录";
      }
    },
    zhanghao() {
      this.is_pay();
    },
    pass() {
      this.is_pay();
    },
    phone() {
      if (this.$tool.checkPhone(this.phone)) {
        this.getImgCode();
      }else{
        this.imgcodeurl = "";
      }
      
      if (this.$tool.checkPhone(this.phone) && this.imgcode != "") {
        this.getCode = true;
      } else {
        this.getCode = false;
      }
      this.is_pay();
    },
    imgcode() {
      if (this.$tool.checkPhone(this.phone) && this.imgcode != "") {
        this.getCode = true;
      } else {
        this.getCode = false;
      }
    },
    yzm() {
      this.is_pay();
    }
  }
};
</script>















<style scoped>
#rgp {
  padding-bottom: 12%;
}
/**输入框 */
.zhanghao {
  padding: 0.1rem 1rem;
  padding-bottom: 5%;
  padding-top: 1rem;
  background: white;
}
.p-title {
  margin-bottom: 5%;
}
.input-p {
  align-items: center;
  margin-bottom: 4px;
  margin-top: 13px;
}
.input-p span {
  font-size: 14px;
}
.input-p input {
  font-size: 16px;
  text-align: left;
  background: none;
  width: 38%;
  border-bottom: 1px solid #f4f4f4;
}
.yzm-span {
  width: 30%;
  text-align: center;
  right: 0;
  color: #c471f5;
}
.disable {
  color: #ccc;
}
.imgy {
  width: 30%;
  right: 0;
  height: 140%;
}

/**错误提示 */
.error {
  font-size: 12px;
  color: #ff3f34;
  margin-top: 15px;
}
.c-error {
  text-align: center;
  margin-bottom: 10px;
}
.change-an {
  display: inline-block;
  font-size: 13px;
  color: #54a0ff;
  margin-top: 15px;
}
.phone-login p > span:first-child {
  width: 25%;
}

/*充值金额*/
.rechargetip {
  padding: 0.5rem 1rem;
  padding-left: 2.3rem;
  background: url("../../assets/icon (27).png") no-repeat 1rem center #ffe1e1;
  background-size: 1rem;
  font-size: 0.7rem;
  color: #ff6b6b;
}
.rechargetip * {
  vertical-align: middle;
}
.rechargetip a {
  color: #54a0ff;
  text-decoration: underline;
}
.count {
  padding: 0.1rem 1rem;
  padding-top: 1rem;
  margin-bottom: 2rem;
  margin-top: 1px;
}
.count > p {
  font-size: 14px;
  color: #999;
  margin-bottom: 0.5rem;
}
ul {
  justify-content: flex-start;
  flex-wrap: wrap;
}
li {
  padding: 0.6rem 0;
  text-align: center;
  width: 30%;
  margin-bottom: 0.5rem;
  margin-right: 5%;
  border-radius: 0.4rem;
  -webkit-border-radius: 0.4rem;
  border: 2px solid #fff;
}
li:nth-child(3n) {
  margin-right: 0;
}
li .p1 * {
  vertical-align: middle;
}
li .p1 {
  font-size: 15px;
  font-weight: bold;
  margin-bottom: 6px;
}
li .p2 {
  font-size: 0.8rem;
  vertical-align: middle;
  color: #999;
  font-weight: 600;
}
i {
  font-style: normal;
  color: #999;
  font-size: 0.8rem;
  font-weight: 400;
}
.active {
  position: relative;
  border-radius: 0.4rem;
  -webkit-border-radius: 0.4rem;
  border: 2px solid #c471f5;
}
.active::after {
  position: absolute;
  display: inline-block;
  content: "";
  background: url("../../assets/icon (22).png") no-repeat center;
  background-size: 100% 100%;
  width: 0.8rem;
  height: 0.8rem;
  bottom: 3px;
  right: 3px;
}
img {
  width: 100%;
  height: 100%;
}

.an {
  text-align: center;
  margin-bottom: 1.5rem;
}
.an button {
  padding: 0.6rem 2.8rem;
  color: #fff;
  background: -webkit-linear-gradient(
    left,
    #fa71cd,
    #c471f5
  ); /* Safari 5.1 - 6.0 */
  background: linear-gradient(to right, #fa71cd, #c471f5); /* 标准的语法 */
  border-radius: 3rem;
  -webkit-border-radius: 3rem;
  font-size: 0.8rem;
}
.an .opacity {
  background: rgba(255, 255, 255, 0.5);
}
.clicked {
  background: #666;
}

/**个人信息 */
.mine {
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 0;
  padding: 10px 1rem;
  background: white;
  justify-content: space-between;
}
.mine img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 5px;
}
.mine > div {
  margin-right: 17px;
}
.mine .p1 {
  font-size: 14px;
  max-width: 80px;
  margin-bottom: 4px;
}
.mine .p2 {
  font-size: 12px;
  color: #999;
}
.mine .balance {
  margin: 0;
}
.mine .balance .p2 {
  font-size: 15px;
  color: #333;
}
.mine .balance .p1 {
  font-size: 13px;
  color: #999;
}
.mine > span {
  font-size: 14px;
  align-items: center;
}
</style>
